import EventLocation from 'src/entities/event-location/EventLocation';

export default class EventLocationBooking extends EventLocation {
	constructor(json: any) {
		super(json);
	}
}
